import request from "@/utils/request";
import { getCurrentBusiness } from "@/utils/auth";

export function getBusinessInfo() {
  var url = "api/business";
  var currentBusiness = getCurrentBusiness();

  if (currentBusiness != null) {
    url = url + "?currentBusinessId=" + currentBusiness.id;
  }

  return request({
    url: url,
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/business.js